import { useHistory } from 'react-router-dom';
import store from '@/store';
import styles from '@/components/GetVerified/GetVerified.module.scss';
import classNames from 'classnames';
import ByzzerLink from '../General/ByzzerLink';
import { logout } from '@/services/account.service';
import { sendVerificationEmail } from '@/services/api/csrdata.service';
import { useEffect } from 'react';

export function GetVerified({ className, hasSentVerificationEmailRef, ...props }) {
    const history = useHistory();
    const user = store.getState()?.account?.user;
    const csrEmail = user?.email;
    
    useEffect(() => {
        if (!user) {
            navigateGuestUser();
            return;
        }

        if (user.emailVerified) {
            navigateAuthenticatedUser();
        } else if (!hasSentVerificationEmailRef.current) {
            sendVerificationEmail(csrEmail);
            hasSentVerificationEmailRef.current = true;
        }
    }, [user]);

    function navigateAuthenticatedUser() {
        // There is only one place to go for CSR's after login.
        history.replace({
            pathname: '/newcompanypage',
        });      
    }

    function navigateGuestUser() {
        history.replace({
            pathname: '/signin',
        });      
    }

    const onEmailClick = () => {
        window.location.href = `mailto:${csrEmail}`;
    }

    const onLogoutClick = async () => {
        await logout();
        history.push(`/signin`);
    }

    return (
        <div className={classNames(styles.getVerified, className)}>
            <h1 className={classNames(styles.title, className)}>Your CSR account needs to be verified</h1>

            <div className={classNames(styles.content, className)}>
                <span>
                    To keep the Byzzer CSR platform secure, only valid NIQ email addresses can be used to log in. To
                    verify that your email is still valid, you will receive an email from "ByzzerAlerts" containing a
                    verification link. Once you click that link, you will be able to log in.
                </span>
                <span>
                    The email you are trying to log in with is <ByzzerLink label={csrEmail} onClick={onEmailClick} />. If this is not your NIQ email address,
                    please <ByzzerLink label="log out" onClick={onLogoutClick} /> and sign in with your email.
                </span>
                <span>
                    If the email address looks correct but you haven't received an email, reach out to Byzzer Support.
                </span>
            </div>
        </div>
    );
}
